var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { UiSelect } from '@claims-ia/design-system';
let Select = class Select extends Vue {
    getChoiceLabel(choice) {
        if ('tradKey' in choice)
            return this.$tc(choice.tradKey);
        if ('label' in choice)
            return choice.label;
        return '';
    }
    get labelOptions() {
        return this.choices.map((choice) => this.getChoiceLabel(choice));
    }
    get selectedLabel() {
        var _a, _b;
        if (this.value === null || this.value === undefined) {
            return (_a = this.placeholder) !== null && _a !== void 0 ? _a : '';
        }
        const found = this.choices.find((c) => c.value === this.value);
        return found ? this.getChoiceLabel(found) : (_b = this.placeholder) !== null && _b !== void 0 ? _b : '';
    }
    onSelect(label) {
        const found = this.choices.find((c) => this.getChoiceLabel(c) === label);
        if (found) {
            this.$emit('input', found.value);
        }
    }
};
Select = __decorate([
    Component({
        components: { UiSelect },
        props: {
            value: {
                type: [Boolean, String, Number],
                default: null,
            },
            choices: {
                type: Array,
                required: true,
            },
            placeholder: {
                type: String,
                default: null,
            },
            expanded: {
                type: Boolean,
                default: null,
            },
        },
    })
], Select);
export default Select;
